import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../reducers/common.reducer";
import { getUserService } from '../services/user.service';

const useUserData = () => {
    const [userData, setUserData] = useState(null);

    const dispatch = useDispatch();

    async function getUserData (signal) {
            
        try {
            dispatch(setIsLoading(true))
            let result = await getUserService(signal);
            if(result.data) {
                setUserData(result.data.filter(user => user.role !== 'adminstrator'));
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    useEffect(() => {
            
        const controller = new AbortController();
        const signal = controller.signal;
        getUserData(signal);

        return () => {
            controller.abort();
        }
    }, []);


    return [userData, setUserData]
}

export default useUserData